import { Injectable } from '@angular/core';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { saveAs } from 'file-saver';
import { HelperService } from '../shared/services/helper.service';
import { environment } from 'src/environments/environment';
import { HttpService } from '../shared/services/http.service';
import { ImageBarcode, ImageText, ImageTemplate } from '../models/image.model';
import { HttpHeaders } from '@angular/common/http';
import { GiftCardModel, GiftCardTypesModel } from '../models/gifcardVirtual.model';




@Injectable()
export class ImageService{

    private PARAMETER_ENDPOINT: string = '/giftCardVirtual';
    private BASE_URL: string = HelperService.buildRequestURL(environment.RipleyGiftCardVirtualApiEndPoint);
    private REQUEST_URL: string = `${this.BASE_URL}${this.PARAMETER_ENDPOINT}`;
    private URL: string;
    public KEY_TEXTO: string = "TEXTO";
    public KEY_DNI: string = "DNI";
    public KEY_NOMBRE: string = "NOMBRE";
    public KEY_SECUENCIAL: string = "SECUENCIAL";
    public KEY_VIGENCIA: string = "VIGENCIA";

    fileModel: File;
    fileModelPath: string;
    canvas: HTMLCanvasElement;
    context: CanvasRenderingContext2D;
    img = new Image();
    zip = new JSZip(); 
    idTypes: number;   

    constructor(private httpService: HttpService){}

    public buildImageUrl(filePath: string){
        this.fileModelPath = filePath;
    }
    
    public createBarcode(barcode: ImageBarcode){
        return new Promise(resolve =>{
            const JsBarcode = require('jsbarcode');
            let canvasBarcode = document.getElementById('canvas2') as HTMLCanvasElement;
            let imgBarcode = new Image();
            
            imgBarcode.crossOrigin = "anonymous";                
            JsBarcode(canvasBarcode, barcode.BIN, {
                height: barcode.SIZE,
                displayValue: barcode.VIEW_VALUE == 0 ? false : true
            });
            imgBarcode.onload = () => {                
                this.loadFondo().then(load =>{
                    if (load){
                        this.context.drawImage(imgBarcode, barcode.AXIS_X, barcode.AXIS_Y);
                        resolve(true);
                    }
                });                
            }
            imgBarcode.src = canvasBarcode.toDataURL("images/jpeg");
            
        });
    }

    public readerFileModel(){
        this.fileModelPath = window.URL.createObjectURL(this.fileModel);
    }

    private loadFondo(){
        this.canvas = document.getElementById('canvas1') as HTMLCanvasElement;
        this.context = this.canvas.getContext("2d");
        this.img = new Image();
        this.img.crossOrigin = "anonymous";   
        this.img.src = this.fileModelPath;
        //this.img.src = "http://127.0.0.1:8887/test1.jpg";
        return new Promise(resolve =>{                     
            this.img.onload = () => {  
                this.canvas.width = this.img.width;
                this.canvas.height = this.img.height;
                this.context.drawImage(this.img, 0, 0);                
                resolve(true);                           
            }    
        });
    }

    public textImage(data: ImageText[]){    
        let texto: string;
        this.context.beginPath();
        data.forEach(item => {
            texto = item.TEXT ? item.TEXT : '';
            this.context.fillStyle = item.TEXT_COLOR;
            item.FONT_SIZE = item.TEXT_FONT_SIZE + 'px ' + item.TEXT_FONT;
            this.context.font = item.FONT_SIZE;
            this.context.fillText(texto, item.AXIS_X, item.AXIS_Y);
        });
        this.context.closePath();         
        this.context.fill();
    }
    
    public downloadImage(){
        this.canvas.toBlob(function(blob) {
            saveAs(blob, "image.jpeg");
        });
    }

    public urlToPromise(url) {
        return new Promise(function(resolve, reject) {
            JSZipUtils.getBinaryContent(url, function (err, data) {
                if(err) {
                    console.log(err);
                    reject(err);
                } else {
                    resolve(data);
                }
            });
        });
    }

    public getCanvas(){
        return this.canvas;
    }

    public getContext(){
        return this.context;
    }

    public GetGiftCardTemplate() {
        this.URL = `${this.REQUEST_URL}/getTemplates`;
        return this.httpService.get<ImageTemplate[]>(this.URL);
    }

    public GetGiftCardTemplateByClityp(params) {
        this.URL = `${this.REQUEST_URL}/getGiftCardTemplateByClityp`;
        return this.httpService.post<ImageTemplate[]>(this.URL, params);
    }

    public GetGiftCardBarcode(params) {
        this.URL = `${this.REQUEST_URL}/getGiftCardBarcode`;
        return this.httpService.post<ImageBarcode[]>(this.URL, params);
    }

    public GetGiftCardText(params) {
        this.URL = `${this.REQUEST_URL}/getGiftCardText`;
        return this.httpService.post<ImageText[]>(this.URL, params);
    }

    public GetGiftCardModelById(params) {
        this.URL = `${this.REQUEST_URL}/getGiftCardModelById`;
        return this.httpService.post<GiftCardTypesModel[]>(this.URL, params);
    }

    public CreateGiftCardModel(item){
        this.URL = `${this.REQUEST_URL}/createGiftCardModel`;
        return this.httpService.post<any>(this.URL, item);
    }

    public CreateGiftCardTemplate(formData: any){
        const httpOptions = {
              headers: new HttpHeaders({
                'Accepted-Encoding': 'form-data'
          })
        };
        this.URL = `${this.REQUEST_URL}/createGiftCardTemplate`;
        return this.httpService.post<any>(this.URL, formData, httpOptions);
    }

    public CreateImageBarcode(item){
        this.URL = `${this.REQUEST_URL}/createImageBarcode`;
        return this.httpService.post<any>(this.URL, item);
    }

    public CreateImageText(item){
        this.URL = `${this.REQUEST_URL}/createImageText`;
        return this.httpService.post<any>(this.URL, item);
    }

    public UpdateGiftCardModel(params){
        this.URL = `${this.REQUEST_URL}/updateGiftCardModel`;
        return this.httpService.put<any>(this.URL, params);
    }

    public UpdateGiftCardTemplate(params){
        this.URL = `${this.REQUEST_URL}/UpdateGiftCardTemplate`;
        return this.httpService.put<any>(this.URL, params);
    }

    public UpdateGiftCardBarcode(params){
        this.URL = `${this.REQUEST_URL}/updateGiftCardBarcode`;
        return this.httpService.put<any>(this.URL, params);
    }

    public UpdateGiftCardText(params){
        this.URL = `${this.REQUEST_URL}/updateGiftCardText`;
        return this.httpService.put<any>(this.URL, params);
    }

    public setModelEdit(model: GiftCardModel){
        sessionStorage.setItem("model", JSON.stringify(model));
    }

    public getModelEdit(){
        return sessionStorage.getItem("model");
    }

    public removeModelEdit(){
        sessionStorage.removeItem("model");
    }

    public setTemplateEdit(template: ImageTemplate){
        sessionStorage.setItem("template", JSON.stringify(template));
    }

    public getTemplateEdit(){
        return sessionStorage.getItem("template");
    }

    public removeTemplateEdit(){
        sessionStorage.removeItem("template");
    }

    public defaultItemTableImageBarcode(): ImageBarcode[]{
        let dataImageBarcode: ImageBarcode[] = [];
        let itemBarcode: ImageBarcode = {
            ID_BARCODE: 0,
            ID_TYPES: 0,
            BIN: '',
            AXIS_X: 190,
            AXIS_Y: 720,
            SIZE: 80,
            VIEW_VALUE: 0,
            CREATIONUSER: '',
            CREATIONDATE: '',
            FLG_ACTIVO: 1
        }
        dataImageBarcode.push(itemBarcode);
        return dataImageBarcode;
    }

    public defaultItemsTableImageText():ImageText[]{
        let dataImageText: ImageText[] = [];
        let itemText: ImageText = {
            ID_TEXT: 0,
            ID_TYPES: 0,
            KEY_TEXT: this.KEY_TEXTO,
            TEXT: '',
            AXIS_X: 240,
            AXIS_Y: 515,
            TEXT_COLOR: 'white',
            TEXT_FONT: 'Arial',
            TEXT_FONT_SIZE: 20,
            FONT_SIZE: '',
            CREATIONUSER: '',
            CREATIONDATE: '',
            FLG_ACTIVO: 1
        }
        dataImageText.push(itemText);

        itemText = {
            ID_TEXT: 0,
            ID_TYPES: 0,
            KEY_TEXT: this.KEY_NOMBRE,
            TEXT: '',
            AXIS_X: 240,
            AXIS_Y: 540,
            TEXT_COLOR: 'white',
            TEXT_FONT: 'Arial',
            TEXT_FONT_SIZE: 20,
            FONT_SIZE: '',
            CREATIONUSER: '',
            CREATIONDATE: '',
            FLG_ACTIVO: 1
        }
        dataImageText.push(itemText);

        itemText = {
            ID_TEXT: 0,
            ID_TYPES: 0,
            KEY_TEXT: this.KEY_DNI,
            TEXT: '',
            AXIS_X: 240,
            AXIS_Y: 565,
            TEXT_COLOR: 'white',
            TEXT_FONT: 'Arial',
            TEXT_FONT_SIZE: 20,
            FONT_SIZE: '',
            CREATIONUSER: '',
            CREATIONDATE: '',
            FLG_ACTIVO: 1
        }
        dataImageText.push(itemText);

        itemText = {
            ID_TEXT: 0,
            ID_TYPES: 0,
            KEY_TEXT: this.KEY_SECUENCIAL,
            TEXT: '',
            AXIS_X: 470,
            AXIS_Y: 725,
            TEXT_COLOR: 'black',
            TEXT_FONT: 'Arial',
            TEXT_FONT_SIZE: 8,
            FONT_SIZE: '',
            CREATIONUSER: '',
            CREATIONDATE: '',
            FLG_ACTIVO: 1
        }
        dataImageText.push(itemText);

        itemText = {
            ID_TEXT: 0,
            ID_TYPES: 0,
            KEY_TEXT: this.KEY_VIGENCIA,
            TEXT: '',
            AXIS_X: 200,
            AXIS_Y: 850,
            TEXT_COLOR: 'black',
            TEXT_FONT: 'Arial',
            TEXT_FONT_SIZE: 15,
            FONT_SIZE: '',
            CREATIONUSER: '',
            CREATIONDATE: '',
            FLG_ACTIVO: 1
        }
        dataImageText.push(itemText);

        return dataImageText;
    }

   
}